<template>
  <div id="app">
    <div class="main__content">
      <header :class="{header: currentStep > 0}">
        <div class="filter--blue" />
      </header>
      <main class="container">
        <div
          v-if="currentStep === 0"
          class="container container-header"
        >
          <div class="header-box">
            <div class="container-inner">
              <h1 class="heading-primary">
                Mortgage Rates Near All-time Lows
              </h1>
              <h4 class="sub-heading"> Get a <span class="text--strong">FREE</span> Quote & See For Yourself!</h4>
            </div>
          </div>
        </div>
        <div
          v-if="currentStep === 0"
          class="main-box"
        >
          <div class="container-inner">
            <h2 class="heading-secondary" />
          </div>
          <div class="main-box-bottom">
            <div class="main-box-bottom-triangle" />
          </div>
        </div>
        <ProgressBar
          v-if="currentStep > 0 && currentStep < 12"
          :current-step="currentStep"
          :max-steps="stepsList.length"
        />
        <Form
          v-if="currentStep < 12"
          :step="stepsList[currentStep]"
          @stepValid="changeStep"
          @skipToNext="skipStep"
        />
        <Loader v-if="currentStep === 12" />
      </main>
    </div>
    <Footer />
  </div>
</template>

<script>
import ProgressBar from './components/common/ProgressBar'
import Form from './components/Form'
import Loader from './components/form-elements/Loader'
import Footer from './components/common/Footer'

import axios from 'axios'
import qs from 'qs'

export default {
  components: {
    ProgressBar,
    Form,
    Loader,
    Footer
  },
  data () {
    return {
      currentStep: 0,
      campId: '',
      clickId: '',
      formData: {},
      stepsList: ['property-zip', 'is-veteran', 'property-type', 'property-use', 'property-value', 'mortgage-balance', 'cashout', 'credit-rating', 'home-address', 'personal-info', 'ssn', 'personal-contacts'],
      stepsHistory: []
    }
  },
  watch: {
    '$route' (newValue, oldValue) {
      let toStep = newValue.path.replace(process.env.VUE_APP_SUBDIR + '/', '')
      let fromStep = oldValue.path.replace(process.env.VUE_APP_SUBDIR + '/', '')

      let forward = this.isForward(toStep, fromStep)
      if (forward === false && fromStep !== '' && this.currentStep !== 12) {
        if (this.isVisited(toStep) === true) {
          let previousStepName = this.stepsHistory[this.stepsHistory.indexOf(fromStep) - 1]
          this.currentStep = this.stepsList.indexOf(previousStepName)
        }
      } else {
        window.scrollTo(0, 0)
      }
      if (this.currentStep < 0) {
        this.currentStep = 0
      }
      if (process.env.NODE_ENV === 'production') {
        this.$gtm.push({
          event: 'VirtualPageview',
          virtualPageURL: this.stepsList[this.currentStep],
          virtualPageTitle: this.stepsList[this.currentStep] })
      }
    }
  },
  created () {
    this.getQueryParams()
    this.$router.push({ path: this.stepsList[0], name: this.stepsList[0], query: this.$route.query })
    this.stepsHistory.push(this.stepsList[0])
  },
  mounted: function () {
    window.onbeforeunload = this.leaving
  },
  methods: {
    changeStep (data) {
      let direction = 'next'
      this.formData = data
      // localStorage.formInfo = JSON.stringify(data)
      // localStorage.visitedSites = JSON.stringify(this.stepsHistory)
      if (direction === 'next') {
        if (this.stepsList.length - 1 === this.currentStep) {
          if (this.formData.leadID === '') {
            this.formData.leadID = 'NOTFOUND'
          }
          data.ssn = this.checkData(data.ssn, '')
          data.campId = this.campId
          data.clickId = this.clickId
          let clientID = 1
          this.currentStep++
          axios.post('//' + process.env.VUE_APP_LINK + '/api/form/submit', { 'clientId': clientID, 'formData': qs.stringify(data, { encode: true }) }).then((response) => {
            window.location.href =
                `thank-you.html?campId=${data.campId}&additional_cash=${data.cashout}&address=${data.homeAddress}&bankruptcy=0&contact=${data.firstName} ${data.lastName}&credit_rating=${data.creditScore}&current_balance=${data.mortgageBalance}&email=${data.email}&foreclosure=Never foreclosed&leadid_id=${data.leadID}&loan_purpose=Lower interest rate&phone=${data.usPhone}&phone_2=${data.usPhone}&property_estimated_value=${data.propertyValue}&property_type=${data.homeType}&property_use=${data.homeUsage}&military=${data.veteran}&va_loan=${data.veteran}&zip=${data.zipCode}`
          }).catch((e) => {
            console.log(e)
          })
        } else {
          this.currentStep++
          this.$router.push({ path: this.stepsList[this.currentStep], name: this.stepsList[this.currentStep], query: this.$route.query })
        }
        this.insertValue(this.currentStep, this.stepsList[this.currentStep])
      } else {
        this.currentStep--
      }
    },
    skipStep (data) {
      this.formData = data
      this.stepsHistory.splice(this.currentStep + 1, 1)
      this.currentStep += 2
      this.$router.push({ path: this.stepsList[this.currentStep], name: this.stepsList[this.currentStep], query: this.$route.query })
      this.insertValue(this.currentStep, this.stepsList[this.currentStep])
      // localStorage.formInfo = JSON.stringify(data)
    },
    isForward (to, from) {
      return (this.stepsList.indexOf(to) >= this.stepsList.indexOf(from))
    },
    isVisited (to) {
      return (this.stepsHistory.indexOf(to) > -1)
    },
    insertValue (index, value) {
      if (!this.stepsHistory.includes(this.stepsList[this.currentStep])) this.stepsHistory.splice(index, 0, value)
    },
    checkData (index, value = '') {
      return (!index) ? value : index
    },
    leaving (e) {
      if (this.currentStep < 12) {
        e.returnValue = false
      }
    },
    getQueryParams () {
      let queryParams = this.$route.query
      this.clickId = queryParams['clickid']
      this.campId = queryParams['campid']
      this.isSmsCampaign(queryParams)
    },
    isSmsCampaign (params) {
      if (params['phone'] && params['smsCampaignId']) {
        axios.post('/formApi.php?a=logClicks&' + qs.stringify(params)).then(res => {
          console.log('ok')
        }).catch(ex => {
          console.log(';(')
        })
        const data = {
          phone: params['phone'],
          smsCampaignId: parseInt(params['smsCampaignId'])
        }
        axios.post('//' + process.env.VUE_APP_LINK + '/api/mortgage/click', data)
          .catch(e => {
            console.log(e)
          })
      }
    }
  }
}
</script>
